export const ERROR_CODES = {
    BAD_REQUEST: "BAD_REQUEST",
    NOT_FOUND: "NOT_FOUND",
    FORBIDDEN: "FORBIDDEN",
    ROOM_CLOSED: "ROOM_CLOSED",
    ROOM_FULL: "ROOM_FULL",
    EXPIRED: "EXPIRED",
    CONFLICT: "CONFLICT",
};
export class ApiError extends Error {
    code;
    status;
    constructor(code, status, message) {
        super(message ?? code);
        this.name = "ApiError";
        this.code = code;
        this.status = status;
    }
}
export function apiErrorBody(code, message) {
    return message ? { error: code, message } : { error: code };
}
//# sourceMappingURL=errors.js.map